class ContactMap extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.addEventListener('load', this.initMap.bind(this));
  }

  initMap() {
    this.myLatLng = {
      lat: 37.33978846072713,
      lng: -79.50813605060836
    };

    var map = new google.maps.Map(this, {
      zoom: 10,
      center: this.myLatLng
    });

    var marker = new google.maps.Marker({
      position: this.myLatLng,
      map: map
    });

    var infoWindow = new google.maps.InfoWindow({
      content: '<p>Southern Flavoring Company, Inc.<br />1330 Norfolk Avenue<br />Bedford, VA 24523</p>'
    });

    marker.addListener('click', function() {
      infoWindow.open(map, marker);
    });
  }
}

customElements.define('contact-map', ContactMap);
